import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "preview-avatar active-avatar"
};
var _hoisted_2 = {
  class: "avatar-layer avatar-layer1"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "avatar-layer avatar-layer2"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "avatar-layer avatar-layer3"
};
var _hoisted_7 = ["src"];
import { MessagePlugin } from "tdesign-vue-next";
import { uploadObs } from "hxhy-obs";
import { reactive, watch } from 'vue';
export default {
  __name: 'generateImg',
  props: {
    activeUrl: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var avatar = require('@/assets/defaultAvatar1.png');
    var props = __props;

    // 图片缓存 - 按URL缓存已加载的图片
    var imageCache = reactive({});

    // 加载单个图片，如果缓存中有直接返回
    var loadImage = function loadImage(url) {
      return new Promise(function (resolve, reject) {
        if (imageCache[url]) {
          resolve(imageCache[url]);
          return;
        }
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          imageCache[url] = img;
          resolve(img);
        };
        img.onerror = reject;
        img.src = url;
      });
    };

    // 预加载当前选中的所有图片
    var preloadImages = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var urls;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              urls = [props.activeUrl.avatar || avatar, props.activeUrl.avatarFrame, props.activeUrl.pendant].filter(Boolean);
              _context.n = 1;
              return Promise.all(urls.map(function (url) {
                return loadImage(url);
              }));
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function preloadImages() {
        return _ref2.apply(this, arguments);
      };
    }();

    // 当activeUrl变化时重新预加载
    watch(function () {
      return props.activeUrl;
    }, function (val) {
      preloadImages();
      console.log(val);
    }, {
      deep: true,
      immediate: true
    });

    // 上传单个文件
    var uploadFile = function uploadFile(file) {
      return new Promise(function (resolve, reject) {
        var accessInfo = JSON.parse(localStorage.getItem('accessInfo'));
        var institutionInfo = JSON.parse(localStorage.getItem('userInfo'));
        var bucketSuffix = ['dev', 'test', 'pre', 'prod'].find(function (v) {
          return location.host.includes(v);
        }) || 'prod';
        var opt = {
          bucketName: "hxhy-base-".concat(bucketSuffix),
          file: file,
          fileType: 1,
          // 2表示视频文件
          userId: accessInfo.content.user_id,
          userName: accessInfo.content.username,
          institutionId: institutionInfo.content.institutionId,
          institutionName: institutionInfo.content.institutionName,
          appCode: 'questionnaireSurvey',
          appName: '调查问卷',
          pageName: 'edit',
          btnName: '选项图片'
        };
        uploadObs(opt).then(function (res) {
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    };
    var generateAvatar = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var canvasSize, canvas, padding, ctx, avatarUrl, avatarImg, frameImg, pendantSize, pendantImg, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              // 创建canvas，分辨率 120x120
              canvasSize = 120;
              canvas = document.createElement('canvas');
              canvas.width = canvasSize;
              canvas.height = canvasSize;
              padding = 2; // 可以根据需要调整内边距，保持头像完整显示
              ctx = canvas.getContext('2d');
              if (ctx) {
                _context3.n = 1;
                break;
              }
              MessagePlugin.error('头像生成失败');
              return _context3.a(2, null);
            case 1:
              // 清空背景透明
              ctx.clearRect(0, 0, canvasSize, canvasSize);

              // 按层级顺序绘制：背景头像 -> 头像框 -> 挂件
              // 第一层：背景头像 - 占满整个canvas，保持完整
              avatarUrl = props.activeUrl.avatar || avatar;
              _context3.n = 2;
              return loadImage(avatarUrl);
            case 2:
              avatarImg = _context3.v;
              ctx.drawImage(avatarImg, 0, 0, canvasSize, canvasSize);

              // 第二层：头像框 - 占满整个canvas
              if (!props.activeUrl.avatarFrame) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return loadImage(props.activeUrl.avatarFrame);
            case 3:
              frameImg = _context3.v;
              ctx.drawImage(frameImg, 0, 0, canvasSize, canvasSize);
            case 4:
              if (!props.activeUrl.pendant) {
                _context3.n = 6;
                break;
              }
              pendantSize = Math.round(25 * 120 / 70);
              _context3.n = 5;
              return loadImage(props.activeUrl.pendant);
            case 5:
              pendantImg = _context3.v;
              ctx.drawImage(pendantImg, 0, canvasSize - pendantSize, pendantSize, pendantSize);
            case 6:
              return _context3.a(2, new Promise(function (resolve, reject) {
                canvas.toBlob(/*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(blob) {
                    var file, url, _t;
                    return _regenerator().w(function (_context2) {
                      while (1) switch (_context2.p = _context2.n) {
                        case 0:
                          _context2.p = 0;
                          file = new File([blob], "avatar_".concat(Date.now(), ".png"), {
                            type: 'image/png'
                          });
                          _context2.n = 1;
                          return uploadFile(file);
                        case 1:
                          url = _context2.v;
                          resolve(url);
                          _context2.n = 3;
                          break;
                        case 2:
                          _context2.p = 2;
                          _t = _context2.v;
                          console.error(_t);
                          MessagePlugin.error('头像生成失败');
                          reject('头像生成失败');
                        case 3:
                          return _context2.a(2);
                      }
                    }, _callee2, null, [[0, 2]]);
                  }));
                  return function (_x) {
                    return _ref4.apply(this, arguments);
                  };
                }(), 'image/png', 0.95);
              }));
            case 7:
              _context3.p = 7;
              _t2 = _context3.v;
              console.error(_t2);
              MessagePlugin.error('头像生成失败');
              return _context3.a(2, null);
          }
        }, _callee3, null, [[0, 7]]);
      }));
      return function generateAvatar() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 暴露方法给父组件调用
    __expose({
      generateAvatar: generateAvatar,
      preloadImages: preloadImages
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(_toDisplayString(__props.activeUrl) + " ", 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: __props.activeUrl.avatar || _unref(avatar),
        alt: "",
        class: "layer-img",
        crossorigin: "anonymous"
      }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [__props.activeUrl.avatarFrame ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.activeUrl.avatarFrame,
        alt: "",
        crossorigin: "anonymous",
        class: "layer-img"
      }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [__props.activeUrl.pendant ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.activeUrl.pendant,
        alt: "",
        crossorigin: "anonymous",
        class: "layer-img"
      }, null, 8, _hoisted_7)) : _createCommentVNode("", true)])]);
    };
  }
};